module.exports = __webpack_public_path__ + "img/middleright3.5bbfda01.png";